import React from "react";
import GenericTable from "./GenericTable";
import { Edit, Delete, InsightsOutlined, OpenInNew } from "@mui/icons-material";
import { IconButton, Tooltip, Box, Chip, Stack } from "@mui/material";

const SurveyTable = ({
  surveys = [],
  rowCount,
  pageSize,
  page,
  onPageChange,
  onPageSizeChange,
  onSearch,
  onEditSurvey,
  onDeleteSurvey,
  onDeleteSelected,
  onViewAnalytics,
  onOpenPublic,
  isLoading,
  canEdit = true,
  canDelete = true,
}) => {
  const rows = surveys.map((survey) => ({
    id: survey.id,
    titulo: survey.titulo || survey.title || "N/A",
    resumo: survey.resumo || survey.description || "N/A",
    status:
      survey.status === "published"
        ? "Publicada"
        : survey.status === "archived"
        ? "Arquivada"
        : "Rascunho",
    metricType: (survey.metricType || "custom").toUpperCase(),
    startedCount: survey.summary?.startedCount ?? 0,
    completedCount: survey.summary?.completedCount ?? 0,
    completionRate:
      survey.summary?.completionRate == null ? "—" : `${survey.summary.completionRate}%`,
    scoreValue:
      survey.summary?.scoreSummary?.mainValue == null
        ? "—"
        : `${survey.summary.scoreSummary.mainValue}`,
    scoreLabel: survey.summary?.scoreSummary?.label || "Score",
    data_cadastro: new Date(
      survey.data_cadastro || survey.createdAt || survey.data_ultima_alteracao
    ).toLocaleDateString(),
  }));

  const columns = [
    { field: "id", headerName: "ID", width: 100 },
    { field: "titulo", headerName: "Título", width: 300 },
    { field: "resumo", headerName: "Resumo", width: 320 },
    {
      field: "metricType",
      headerName: "Métrica",
      width: 120,
      renderCell: (params) => <Chip size="small" label={params.row.metricType} variant="outlined" />,
    },
    {
      field: "status",
      headerName: "Status",
      width: 130,
      renderCell: (params) => (
        <Chip
          size="small"
          label={params.row.status}
          color={
            params.row.status === "Publicada"
              ? "success"
              : params.row.status === "Arquivada"
              ? "default"
              : "warning"
          }
          variant="outlined"
        />
      ),
    },
    { field: "startedCount", headerName: "Iniciadas", width: 110 },
    { field: "completedCount", headerName: "Concluídas", width: 120 },
    { field: "completionRate", headerName: "Conclusão", width: 120 },
    {
      field: "scoreValue",
      headerName: "Score",
      width: 140,
      renderCell: (params) => (
        <Stack direction="row" spacing={1} alignItems="center">
          <Chip size="small" color="primary" label={params.row.scoreValue} />
          <Chip size="small" variant="outlined" label={params.row.scoreLabel} />
        </Stack>
      ),
    },
    { field: "data_cadastro", headerName: "Data de Cadastro", width: 150 },
    {
      field: "actions",
      headerName: "Ações",
      width: 230,
      renderCell: (params) => (
        <Box display="flex" gap={1}>
          <Tooltip title="Analytics">
            <IconButton onClick={() => onViewAnalytics?.(params.row)}>
              <InsightsOutlined />
            </IconButton>
          </Tooltip>
          <Tooltip title="Link público">
            <IconButton onClick={() => onOpenPublic?.(params.row)}>
              <OpenInNew />
            </IconButton>
          </Tooltip>
          <Tooltip title="Editar">
            <IconButton disabled={!canEdit} onClick={() => onEditSurvey(params.row)}>
              <Edit />
            </IconButton>
          </Tooltip>
          <Tooltip title="Excluir">
            <IconButton
              disabled={!canDelete}
              onClick={() => onDeleteSurvey(params.row.id)}
              color="error"
            >
              <Delete />
            </IconButton>
          </Tooltip>
        </Box>
      ),
    },
  ];

  return (
    <GenericTable
      rows={rows}
      columns={columns}
      rowCount={rowCount}
      pageSize={pageSize}
      page={page}
      onPageChange={onPageChange}
      onPageSizeChange={onPageSizeChange}
      onSearch={onSearch}
      isLoading={isLoading}
      onExportPDFTitle="Pesquisas Selecionadas"
      exportFileName="pesquisas"
      onDeleteSelected={onDeleteSelected}
    />
  );
};

export default SurveyTable;
